import { z } from 'zod';
/** A node pack from the manager's own list (doc 34); only `registry` packs are installable from Couch. */
export const NodePackSchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string(),
    author: z.string(),
    repository: z.string(),
    stars: z.number().int(),
    registry: z.boolean(),
    installed: z.boolean().optional(),
});
export const NodePackSearchResponseSchema = z.object({ packs: z.array(NodePackSchema) });
export const NodePacksForNodesResponseSchema = z.object({ nodes: z.record(z.string(), z.array(NodePackSchema)) });
export const InstalledNodePackSchema = z.object({ dir: z.string(), id: z.string(), version: z.string(), enabled: z.boolean() });
export const NodePacksResponseSchema = z.object({
    manager: z.object({ enabled: z.boolean(), version: z.string().nullable(), enabling: z.boolean(), error: z.string().nullable() }),
    installed: z.array(InstalledNodePackSchema),
});
export const NODE_INSTALL_STATUSES = ['awaiting_approval', 'queued', 'installing', 'restarting', 'done', 'failed', 'declined'];
export const NodeInstallStatusSchema = z.enum(NODE_INSTALL_STATUSES);
export const NodeInstallSchema = z.object({
    id: z.string(),
    machineId: z.string(),
    packId: z.string(),
    requestedBy: z.enum(['human', 'ai']),
    reason: z.string().nullable(),
    status: NodeInstallStatusSchema,
    error: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const NodeInstallResponseSchema = z.object({ install: NodeInstallSchema });
export const NodeInstallsResponseSchema = z.object({ installs: z.array(NodeInstallSchema) });
export const NodeInstallRequestSchema = z.object({
    packId: z.string().trim().min(1).max(200).regex(/^[A-Za-z0-9._-]+$/, 'A Comfy Registry pack id'),
    /** Why the AI wants it — shown to the owner when approving. */
    reason: z.string().trim().max(300).optional(),
});
export const AccountSettingsSchema = z.object({ aiInstallsWithoutAsking: z.boolean() });
export const AccountSettingsResponseSchema = z.object({ settings: AccountSettingsSchema });
//# sourceMappingURL=nodepacks.js.map